module.exports = __webpack_public_path__ + "media/images/riders/JULIE_BRESSET-4c62ead8f8155bacea8177cb9505b7fb.png";